const OrganizationLoading = () => (
    <div className="bg-white p-2 sm:p-4 rounded-2xl shadow-md flex flex-col gap-5 select-none ">
        <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
        <div className="bg-gray-200 w-full animate-pulse h-12 rounded-2xl" />
    </div>
);

export default OrganizationLoading;